<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="推送渠道">
              <a-select
                placeholder="请选择推送渠道"
                v-model="queryParam.asoActivity"
              >
                <a-select-option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />删除</a-menu-item
          >
          <a-menu-item key="2" @click="changeStatus('1')"
            ><a-icon type="eye" />批量启用</a-menu-item
          >
          <a-menu-item key="3" @click="changeStatus('0')"
            ><a-icon type="eye-invisible" />批量停用</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        class="j-table-force-nowrap"
        @change="handleTableChange"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无图片</span
          >
          <img
            v-else
            :src="getImgView(text)"
            height="25px"
            alt=""
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic"
            >无文件</span
          >
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)"
          >
            下载
          </a-button>
        </template>
        <template slot="status" slot-scope="text, record">
          <a-switch
            :checked="isChecked(record.status)"
            checked-children="启用"
            un-checked-children="未启用"
            @click="handleChange(record)"
          />
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handlDelete(record)">删除</a>
        </span>
      </a-table>
    </div>

    <horse-race-modal
      ref="modalForm"
      @ok="modalFormOk"
      :channelList="channelList"
    ></horse-race-modal>
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import HorseRaceModal from './modules/HorseRaceModal';
import { postAction, getAction } from '../../../api/manage';
import { filterObj } from '@/utils/util';
export default {
  name: 'HorseRace',
  mixins: [mixinDevice],
  components: {
    HorseRaceModal,
  },
  data() {
    return {
      description: '跑马灯管理页面',
      // 表头
      columns: [
        {
          title: '推送标题',
          align: 'center',
          dataIndex: 'pmdName',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 10
              ? text.substr(0, 10) + '...'
              : text;
          },
        },
        {
          title: '跳转链接',
          align: 'center',
          dataIndex: 'pmdUrl',
          customRender: function (text) {
            return !text
              ? ''
              : text.length > 20
              ? text.substr(0, 20) + '...'
              : text;
          },
        },
        {
          title: '推送渠道',
          align: 'center',
          dataIndex: 'asoActivity_dictText',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
        },
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'status_dictText',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          scopedSlots: { customRender: 'action' },
        },
      ],
      dataSource: [],
      selectedRowKeys: [],
      selectionRows: [],
      loading: false,
      queryParam: {
        asoActivity: undefined,
      },
      /* 分页参数 */
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/horse/race/list',
        delete: process.env.VUE_APP_CMS_CONTENT + '/horse/race/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/horse/race/deleteBatch',
        updateStatus:
          process.env.VUE_APP_CMS_CONTENT + '/horse/race/updateStatus',
        channelList: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/list',
      },
      dictOptions: {},
      channelList: [], //推送渠道
    };
  },
  computed: {},
  created() {
    this.loadDataTmp();
    this.initDictConfig();
  },
  methods: {
    initDictConfig() {
      let param = {
        pageNo: '',
        pageSize: 10000000,
      };
      getAction(this.url.channelList, param).then((res) => {
        if (res.success) {
          this.channelList =
            res.result && res.result.records ? res.result.records : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    //批量启用、停用
    changeStatus(num) {
      var title_tmp = '';
      var content_tmp = '';
      if (num === '1') {
        title_tmp = '确认启用';
        content_tmp = '是否启用选中数据';
      } else {
        title_tmp = '确认停用';
        content_tmp = '是否停用选中数据';
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        let ids = this.selectedRowKeys;
        ids = ids.join(',');
        console.log(this.selectedRowKeys, '>>>>', ids);
        let that = this;
        this.$confirm({
          title: title_tmp,
          content: content_tmp,
          onOk: function () {
            that.loading = true;
            postAction(that.url.updateStatus, { ids: ids, type: num })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  //刷新页面
                  that.loadDataTmp();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },

    //启用、停用
    handleChange(record) {
      let strOpen = '确定要启用所选数据?';
      let strClose = '确定要停用所选数据?';
      let that = this;
      let type = record.status == 1 ? 0 : 1;
      this.$confirm({
        title: record.status == 1 ? '停用' : '启用',
        content: record.status == 1 ? strClose : strOpen,
        onOk() {
          postAction(that.url.updateStatus, {
            ids: record.id,
            type: type,
          }).then((res) => {
            if (res.success) {
              //刷新页面
              that.loadDataTmp();
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
            }
          });
        },
      });
    },

    isChecked(statusTemp) {
      if (statusTemp == 1) {
        return true;
      } else return false;
    },
    //删除
    handlDelete(record) {
      console.log(record);
      if (record.status == '1') {
        return this.$message.warning('已启用的数据不能删除');
      } else {
        let that = this;
        that.$confirm({
          title: '提示',
          content: '确定要删除吗',
          onOk: function () {
            postAction(that.url.delete, { id: record.id }).then((res) => {
              if (res.success) {
                that.loadDataTmp();
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            });
          },
        });
      }
    },

    //添加
    handleAdd: function (course) {
      if (course) {
        if (course.type == 'click') {
          course = undefined;
        }
      }
      this.$refs.modalForm.add(course);
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //清空选中的数据
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      let isuse = record.isuse == 1 ? '是' : '否';
      let type = record.qtype == 1 ? '机构' : '个人';
      record.type = type;
      record.isuse = isuse;
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },

    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    //批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        let that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.loadDataTmp();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.loadDataTmp();
    },
    searchQuery() {
      this.loadDataTmp(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      if (this.$route.query.type != 4) {
        this.loadDataTmp(1);
      }
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = 'ascend' == sorter.order ? 'asc' : 'desc';
      }
      this.ipagination = pagination;
      this.loadDataTmp();
    },
    loadDataTmp() {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      this.loading = true;
      let params = this.getQueryParams();
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.dataSource = res.result.records;
          this.ipagination.total = res.result.total;
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
